module.exports = __webpack_public_path__ + "officialStatic/img/pse1.53a5553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pse1.png
// module id = tM21
// module chunks = 0